module.exports = __webpack_public_path__ + "static/media/challenge-background-done-flowers.7cf29c16.svg";